import { LecBankAccount } from '../../lib/types/models/lec-bank-account/lec-bank-account'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getLecBankAccount(id: number) {
  return restApiClient
    .url(constructApiUrl(API.lecBankAccounts.get.url, { id }))
    .get<LecBankAccount>()
}
